import * as React from 'react';

import { cn } from '@nfctron/nexus-react';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';

const UiRadioGroup = ({
	ref,
	className,
	...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
	ref?: React.RefObject<React.ElementRef<typeof RadioGroupPrimitive.Root>>;
}) => {
	return <RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />;
};
UiRadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const UiRadioGroupItem = ({
	ref,
	className,
	...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
	ref?: React.RefObject<React.ElementRef<typeof RadioGroupPrimitive.Item>>;
}) => {
	return (
		<RadioGroupPrimitive.Item
			ref={ref}
			className={cn(
				'aspect-square size-4 rounded-full border border-zinc-200 text-zinc-900 ring-offset-white focus:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-zinc-50 dark:border-zinc-800 dark:text-zinc-50 dark:ring-offset-zinc-950 dark:focus-visible:ring-zinc-300',
				className,
			)}
			{...props}
		>
			<RadioGroupPrimitive.Indicator className="flex items-center justify-center">
				<Circle className="h-2.5 w-2.5 fill-current text-current" />
			</RadioGroupPrimitive.Indicator>
		</RadioGroupPrimitive.Item>
	);
};
UiRadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { UiRadioGroup, UiRadioGroupItem };
